<cdk-accordion class="accordion-field-type">
  <cdk-accordion-item
    #accordionItem="cdkAccordionItem"
    class="accordion-field-type-item"
    role="button"
    tabindex="0"
    [attr.id]="'accordion-header-' + 0"
    [attr.aria-expanded]="accordionItem.expanded"
    [attr.aria-controls]="'accordion-body-' + 0"
    >
    <ng-container *ngIf="field?.props?.isForStepBuilder ===  true && field.fieldGroup && field.fieldGroup.length === 0">
      <button (click)="addFieldForStepBuilder($event)" [matMenuTriggerFor]="stepFieldsMenu" mat-flat-button color="primary" class="btn btn-primary btn-with-icon">
          <mat-icon>add</mat-icon>
          Add Step
      </button>

      <mat-menu #stepFieldsMenu="matMenu">
        
      </mat-menu>
    </ng-container>
    <ng-container *ngIf="!field?.props?.isForStepBuilder || field.fieldGroup && field.fieldGroup.length > 0">
    <div class="accordion-field-type-item-header" (click)="accordionItem.toggle()">
      <span class="accordion-arrow">
        <i class="material-icons">{{ accordionItem.expanded ? 'arrow_drop_up' : 'arrow_drop_down' }}</i>
      </span> 
      <div>
        <div class="accordion-title">
          {{ field.props.label }}
        </div>
        <p class="mb-0" *ngIf="isHtml" [innerHtml]="field.props.description">
        </p>
        <p class="mb-0" *ngIf="!isHtml" [innerText]="field.props.description">
        </p>
      </div>
    </div>
    
    <div
      
      class="accordion-field-type-item-body"
      role="region"
      [style.display]="accordionItem.expanded ? '' : 'none'"
      [attr.id]="'accordion-body-' + 0"
      [attr.aria-labelledby]="'accordion-header-' + 0"
      >
      <ng-container *ngIf="field?.props?.mode === 'attach'">
        <app-restriction></app-restriction>
      </ng-container>
      <ng-container *ngFor="let tab of field.fieldGroup; let index = index; let last = last">
        <formly-field [field]="tab"></formly-field>
      </ng-container>
    </div>
  </ng-container>
</cdk-accordion-item>
</cdk-accordion>

